import { h } from './dom.js'

let root = null

export function mountToasts(parent) {
  root = h('div.toast-root', { 'aria-live': 'polite' })
  parent.appendChild(root)
  return root
}

export function toast(message, { kind = 'info', duration = 2600 } = {}) {
  if (!root) return
  const el = h(`div.toast.toast-${kind}`, {}, message)
  root.appendChild(el)
  requestAnimationFrame(() => el.classList.add('show'))
  setTimeout(() => {
    el.classList.remove('show')
    setTimeout(() => el.remove(), 250)
  }, duration)
}
